import { Link } from "react-router-dom";
import { Siren } from "lucide-react";
import { CallButton } from "./CallButton";
import { useLang } from "../../i18n/LangContext";

export const MobileBar = () => {
  const { t } = useLang();
  return (
    <div className="fixed bottom-0 inset-x-0 z-50 md:hidden border-t border-[#2E2E3A] bg-[#121216]/95 backdrop-blur-md p-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] flex gap-3" data-testid="mobile-sticky-bar">
      <CallButton testId="sticky-call-btn" className="flex-1 py-3.5 text-sm" />
      <Link to="/request" data-testid="sticky-help-btn" className="btn-red flex-1 py-3.5 text-sm">
        <Siren className="h-5 w-5" aria-hidden="true" /> {t("cta.requestHelp")}
      </Link>
    </div>
  );
};
